import React, { useMemo } from 'react';
import { GenericListPage } from '../../components/generic';
import type { SupplyRequisition } from '../../modules/supplies/requisitions/useData';
import { useAccountVesselScope } from '../../hooks/useAccountVesselScope';
import { VesselRequisitionsListProvider, useVesselRequisitionsListData } from './useData';
import { createVesselRequisitionsModuleConfig, getColumns, getToolbarIcon } from './vesselRequisitionsModuleConfig';

const List: React.FC = () => {
  const vid = useAccountVesselScope();

  const bundle = useMemo(
    () => (vid != null && Number.isFinite(vid) ? createVesselRequisitionsModuleConfig(vid) : null),
    [vid],
  );

  const config = useMemo(() => {
    if (!bundle) return null;
    return {
      ...bundle.moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions: bundle.getTableActions,
    };
  }, [bundle]);

  if (vid == null || !Number.isFinite(vid) || !config) {
    return <p className="text-sm text-red-600 dark:text-red-400">Invalid vessel.</p>;
  }

  return (
    <VesselRequisitionsListProvider vesselId={vid}>
      <GenericListPage<SupplyRequisition> useData={useVesselRequisitionsListData} config={config} />
    </VesselRequisitionsListProvider>
  );
};

export default List;
